import React, { useEffect, useState } from 'react';
import { Animated, Easing } from 'react-native';

import styles from './position-indicator.style';
import { useColors } from '../../../hooks/lesson-player.context';

interface PositionIndicatorProps {
  fragmentIndex: number;
  fragmentPosition?: number;
  fragmentWidth: number;
  separatorWidth?: number;
  innerColor?: string;
  borderColor?: string;
  animationDurationInMs?: number;
  borderWidth?: number;
}

export function PositionIndicator({
  fragmentIndex,
  fragmentPosition = 0,
  separatorWidth = 0,
  fragmentWidth,
  animationDurationInMs = 150,
  innerColor,
  borderColor,
  borderWidth = 3,
}: PositionIndicatorProps) {
  const [value] = useState(new Animated.Value(0));
  const colors = useColors();
  useEffect(() => {
    const toValue =
      separatorWidth / 2 +
      (fragmentWidth + separatorWidth) * fragmentIndex +
      fragmentPosition * fragmentWidth -
      9;

    if (isNaN(toValue)) {
      return;
    }

    Animated.timing(value, {
      toValue,
      duration: animationDurationInMs,
      useNativeDriver: false,
      easing: Easing.out(Easing.linear),
    }).start();
  }, [
    fragmentIndex,
    fragmentPosition,
    separatorWidth,
    value,
    fragmentWidth,
    animationDurationInMs,
  ]);

  return (
    <Animated.View
      style={[
        styles.indicator,
        {
          borderWidth,
          backgroundColor: innerColor || colors.background,
          borderColor: borderColor || colors.primary,
          transform: [{ translateX: value }],
        },
      ]}
    />
  );
}
